<template>
  <require from="framework/html_behaviors/af-mutex-click"></require>
  <require from="framework/value_converters/date-and-time"></require>
  <require from="framework/value_converters/escape-html"></require>
  <require from="framework/value_converters/with-links"></require>
  <require from="controls/as-form-section.html"></require>
  <require from="controls/as-widget-stack"></require>
  <require from="controls/as-widget-list"></require>
  <require from="controls/as-form-richtexteditor"></require>
  <require from="controls/bs-form-input"></require>
  <require from="controls/bs-form-textarea"></require>
  <require from="controls/bs-form-select"></require>
  <require from="controls/bs-form-switch"></require>

  <as-form-section heading="Basics">
    <div slot="body">
      <div class="form-row">
        <div class="${model.archivedOn ? 'col-md-6' : 'col-md-12'}">
          <bs-form-input type="text" label="Country Name" placeholder="Country unique name" value.bind="model.name & validate" disabled.bind="disabled" maxlength="500" hasfocus.bind="autofocus"></bs-form-input>
        </div>
        <div class="col-md-6" if.bind="model.archivedOn">
          <bs-form-input type="text" label="Archived by ${model.archivedBy.name || model.archivedBy.username}" value.bind="model.archivedOn | dateTime" disabled="true"></bs-form-input>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-6">
          <bs-form-select label="Approval" placeholder="Select approval" value.bind="model.approvalRequirement & validate" options.bind="enumService.approvalRequirements" matcher.bind="enumsItemMatcher" name-path="name" disabled.bind="disabled"></bs-form-select>
        </div>
        <div class="col-md-6">
          <bs-form-select label="Approval Level" placeholder="Select approval level" value.bind="model.approvalLevel & validate" options.bind="approvalLevels" matcher.bind="keywordsItemMatcher" name-path="name" disabled.bind="disabled"></bs-form-select>
        </div>
      </div>
    </div>
  </as-form-section>
  <as-form-section heading="Systems" intro="System variables. Changing can have impact into system functions.">
    <div slot="body">
      <div class="form-row">
        <div class="col-md-6 order-md-0">
          <bs-form-input type="text" label="Alpha 2 ISO Code" placeholder="Alpha 2 ISO Code" value.bind="model.isoCode2 & validate" disabled.bind="disabled" maxlength="2"></bs-form-input>
        </div>
        <div class="col-md-6 order-md-1">
          <bs-form-input type="text" label="Alpha 3 ISO Code" placeholder="Alpha 3 ISO Code" value.bind="model.isoCode3 & validate" disabled.bind="disabled" maxlength="3"></bs-form-input>
        </div>
        <div class="col-md-6 order-md-3">
          <bs-form-input type="text" label="Country Icon" placeholder="Country icon" value.bind="model.icon" maxlength="100" disabled.bind="disabled"></bs-form-input>
        </div>
        <div class="col-md-6 order-md-2">
          <bs-form-switch text="Update ISOS data" checked.bind="model.updateISOSData" disabled.bind="disabled"></bs-form-switch>
        </div>
      </div>
    </div>
  </as-form-section>
  <as-form-section heading="Approval Settings" intro="Manage approval settings for this country.">
    <div slot="body">
      <div class="form-row">
        <div class="col-md-6">
          <bs-form-select label="Approval Category" placeholder="Select approval category" value.bind="model.approveType & validate" options.bind="enumService.approvalTypes" matcher.bind="enumsItemMatcher" name-path="name" disabled.bind="approvalDisabled"></bs-form-select>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-6">
          <bs-form-switch text="Has Specific Condition" checked.bind="model.hasSpecificCondition" disabled.bind="approvalDisabled"></bs-form-switch>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <as-form-richtexteditor label="Specific Condition" placeholder="Specific Condition" disabled.bind="specificConditiondDisabled" value.bind="model.specificCondition & validate"></as-form-richtexteditor>
        </div>
      </div>
    </div>
  </as-form-section>
  <as-form-section heading="Generic Email Addresses" intro="Manage generic email addresses for this country.">
    <div slot="body">
      <div class="form-row">
        <div class="col">
          <as-widget-stack kind="admin-country-email" new-item-widget-visible.bind="genericEmailAddressesEditing" items.bind="model.genericEmailAddressesWrapper" empty-item-template.bind="newEmptyGenericEmailAddressWrapper" disabled.bind="approvalDisabled"></as-widget-stack>
        </div>
      </div>
    </div>
  </as-form-section>
  <as-form-section heading="Approvers" intro="Manage approvers for this country.">
    <div slot="body">
      <div class="form-row">
        <div class="col">
          <as-widget-stack kind="admin-user-selector" widget-buttons.bind="approverButtons" new-item-widget-visible.bind="approversEditing" items.bind="model.approversWrapper" empty-item-template.bind="newEmptyApproverWrapper" disabled.bind="approvalDisabled"></as-widget-stack>
        </div>
      </div>
    </div>
  </as-form-section>
  <as-form-section heading="Travel Overview (mobile app)" intro="Manage travel overview for this country. This overview is displayed in the TravelSafe mobile app.">
    <div slot="body">
      <div class="form-row">
        <div class="col">
          <as-form-richtexteditor label="Travel overview" placeholder="Travel overview" disabled.bind="disabled" value.bind="model.travelOverview"></as-form-richtexteditor>
        </div>
      </div>
    </div>
  </as-form-section>
  <as-form-section heading="Country contacts (mobile app)" intro="Manage contacts for this country. These contacts are displayed in the TravelSafe mobile app.">
    <div slot="body">
      <div class="form-row">
        <div class="col">
          <as-widget-stack kind="admin-user-contact-selector" widget-buttons.bind="contactButtons" new-item-widget-visible.bind="contactsEditing" items.bind="model.contactsWrapper" empty-item-template.bind="newEmptyContactWrapper" disabled.bind="disabled"></as-widget-stack>
        </div>
      </div>
    </div>
  </as-form-section>
  <as-form-section heading="Questions" intro="Following questions are global or linked to this country. To manage them please click the button below.">
    <div slot="body">
      <div class="sc-buttons-container">
        <button type="button" class="btn btn-light" af-mutex-click.call="redirectToQuestions()" disabled.bind="disabled">
          <i class="fas fa-question-circle"></i> Manage questions
        </button>
      </div>
      <div class="form-row">
        <div class="col">
          <ul>
            <li repeat.for="question of model.questions">
              <i class="fas ${(question.isGlobal ? 'fa-globe' : 'fa-flag')}" title="${(question.isGlobal ? 'Global question' : 'Country specific question')}"></i>&nbsp;<span innerhtml="${question.name | escapeHTML | withLinks | sanitizeHTML }"></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </as-form-section>
</template>
